import React, { useState, useEffect } from 'react';
import {Layout, Grid, Typography} from 'antd';
import ProtectedRoute from '../ProtectedRoute';
import SideNavigation from '../SideNavigation';
import ToolsPanel from '../tools/ToolsPanel';
import { useTranslation } from 'react-i18next';
import {LockOutlined} from "@ant-design/icons";
import { useLocation } from 'react-router-dom';
import { useRoutes } from 'react-router-dom';
import { protectedRoutes } from '../../routes';

const { useBreakpoint } = Grid;
const { Paragraph } = Typography;
const { Content, Footer } = Layout;

const ProtectedLayout = ({ children, hideSidenav = false }) => {
  const { t } = useTranslation();
  const location = useLocation();
  const [collapsed, setCollapsed] = useState(false);
  const [toolsPanelWidth, setToolsPanelWidth] = useState(60);
  const screens = useBreakpoint();
  const hideSidenavOnMobile = collapsed && hideSidenav;

  // Pages where ToolsPanel should not be shown
  const excludedPaths = [
    '/', // Home page
    // Add more paths here as needed:
  ];

  // Check if current page should exclude ToolsPanel
  const shouldExcludeToolsPanel = excludedPaths.includes(location.pathname);

  useEffect(() => {
    setCollapsed(!screens.md);
  }, [screens.md]);

  // Listen for tools panel state changes
  useEffect(() => {
    const handleToolsPanelStateChange = (event) => {
      const { width } = event.detail;
      setToolsPanelWidth(width);
    };

    window.addEventListener('toolsPanelStateChange', handleToolsPanelStateChange);
    return () => window.removeEventListener('toolsPanelStateChange', handleToolsPanelStateChange);
  }, []);

  return (
    <ProtectedRoute>
      {hideSidenavOnMobile ? null : (
        <SideNavigation collapsed={collapsed} setCollapsed={setCollapsed} />
      )}
      <Layout
        className='layout'
        style={{
          marginLeft: hideSidenavOnMobile ? 0 : (collapsed ? 80 : 200),
          marginRight: screens.md ? 48 : 0,
          transition: 'margin 0.2s'
        }}
      >
        <Content>
          <div className="site-layout-content">{children}</div>
        </Content>
        <Footer style={{ textAlign: 'center', marginBottom: '10px' }}>
          <Paragraph type="secondary" style={{ marginBottom: '5px' }}>
            <LockOutlined className='iconSpacing' />
            {t('sessions.fields.security_note_encryption')}
          </Paragraph>
        </Footer>
      </Layout>
      {!shouldExcludeToolsPanel && <ToolsPanel />}
    </ProtectedRoute>
  );
};

export default ProtectedLayout;
